import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filterBtn", "list", "item"]
  static values = { personId: Number }

  connect() {
    this.currentFilter = "all"
  }

  filter(event) {
    const filterValue = event.currentTarget.dataset.filter
    this.currentFilter = filterValue

    // Update button styles
    this.filterBtnTargets.forEach(btn => {
      const btnFilter = btn.dataset.filter
      const isActive = btnFilter === filterValue

      // Remove all active/inactive classes first
      btn.classList.remove(
        'bg-slate-900', 'text-white',
        'bg-purple-50', 'text-purple-700', 'hover:bg-purple-100',
        'bg-indigo-50', 'text-indigo-700', 'hover:bg-indigo-100',
        'bg-slate-100', 'text-slate-700', 'hover:bg-slate-200',
        'bg-slate-50', 'text-slate-600', 'hover:bg-slate-100'
      )

      if (isActive) {
        // Active state - dark background
        btn.classList.add('bg-slate-900', 'text-white')
      } else {
        // Inactive state - provider-specific light background
        switch (btnFilter) {
          case 'slack':
            btn.classList.add('bg-purple-50', 'text-purple-700', 'hover:bg-purple-100')
            break
          case 'linear':
            btn.classList.add('bg-indigo-50', 'text-indigo-700', 'hover:bg-indigo-100')
            break
          case 'github':
            btn.classList.add('bg-slate-100', 'text-slate-700', 'hover:bg-slate-200')
            break
          default:
            btn.classList.add('bg-slate-50', 'text-slate-600', 'hover:bg-slate-100')
        }
      }
    })

    // Filter items
    this.itemTargets.forEach(item => {
      const provider = item.dataset.provider
      
      if (filterValue === "all" || provider === filterValue) {
        item.classList.remove('hidden')
      } else {
        item.classList.add('hidden')
      }
    })
  }
}

